import React from "react";
const GenericPreviewIcon = React.forwardRef((props, svgRef) => (
  <svg
    width="213"
    height="213"
    xmlns="http://www.w3.org/2000/svg"
    ref={svgRef}
    {...props}
  >
    <defs>
      <mask
        id="i"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="-2"
        y="-2"
        width="71"
        height="89"
      >
        <path
          fill="#fff"
          d="M76 57h71v89H76z"
        />
        <use xlinkHref="#a" />
      </mask>
      <mask
        id="j"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="-2"
        y="-2"
        width="72"
        height="89"
      >
        <path
          fill="#fff"
          d="M-2-2h72v89H-2z"
        />
        <use xlinkHref="#b" />
      </mask>
      <mask
        id="k"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="-2"
        y="-2"
        width="15"
        height="11"
      >
        <path
          fill="#fff"
          d="M26 32h15v11H26z"
        />
        <use xlinkHref="#c" />
      </mask>
      <mask
        id="l"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="-2"
        y="-2"
        width="72"
        height="89"
      >
        <path
          fill="#fff"
          d="M-2-2h72v89H-2z"
        />
        <use xlinkHref="#d" />
      </mask>
      <mask
        id="m"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="-2"
        y="-2"
        width="15"
        height="11"
      >
        <path
          fill="#fff"
          d="M26 32h15v11H26z"
        />
        <use xlinkHref="#e" />
      </mask>
      <mask
        id="n"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="13.043"
        height="6.552"
        fill="#fff"
      >
        <use xlinkHref="#f" />
      </mask>
      <mask
        id="o"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="13.043"
        height="6.552"
        fill="#fff"
      >
        <use xlinkHref="#g" />
      </mask>
      <mask
        id="p"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="-2"
        y="-2"
        width="33"
        height="33"
      >
        <path
          fill="#fff"
          d="M-2-2h33v33H-2z"
        />
        <use xlinkHref="#h" />
      </mask>
      <path
        id="a"
        d="M78 59h67v85H78z"
      />
      <path
        d="M68 5.313V81.994A3.005 3.005 0 0 1 64.99 85H3.01A3 3 0 0 1 0 82V3a3 3 0 0 1 3.002-3H59.5"
        id="b"
      />
      <path
        d="M33.5 41c3.038 0 5.5-2.216 5.5-4.95 0-2.733-11-2.733-11 0 0 2.734 2.462 4.95 5.5 4.95Z"
        id="c"
      />
      <path
        d="M68 5.313V81.994A3.005 3.005 0 0 1 64.99 85H3.01A3 3 0 0 1 0 82V3a3 3 0 0 1 3.002-3H59.5"
        id="d"
      />
      <path
        d="M33.5 41c3.038 0 5.5-2.216 5.5-4.95 0-2.733-11-2.733-11 0 0 2.734 2.462 4.95 5.5 4.95Z"
        id="e"
      />
      <path
        d="M60.917 4.606c1.047-1.284 2.833-1.371 3.996-.187l4.534 4.62-13.042 1.097 4.512-5.53Z"
        id="f"
      />
      <path
        d="M60.917 4.606c1.047-1.284 2.833-1.371 3.996-.187l4.534 4.62-13.042 1.097 4.512-5.53Z"
        id="g"
      />
      <rect
        id="h"
        x="0"
        y="0"
        width="29"
        height="29"
        rx="3"
      />
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
    >
      <circle
        fill="#7A8FE7"
        cx="106.5"
        cy="106.5"
        r="106.5"
      />
      <text
        fontFamily="ZapfDingbatsITC, Zapf Dingbats"
        fontSize="13"
        fill="#FFF"
      >
        <tspan
          x="53"
          y="90"
        >
          ✦
        </tspan>
      </text>
      <text
        fontFamily="ZapfDingbatsITC, Zapf Dingbats"
        fontSize="27"
        fill="#FFF"
      >
        <tspan
          x="152"
          y="112"
        >
          ✦
        </tspan>
      </text>
      <text
        fontFamily="ZapfDingbatsITC, Zapf Dingbats"
        fontSize="13"
        fill="#FFF"
      >
        <tspan
          x="86"
          y="50"
        >
          ✦
        </tspan>
      </text>
      <text
        fontFamily="ZapfDingbatsITC, Zapf Dingbats"
        fontSize="13"
        fill="#FFF"
      >
        <tspan
          x="125"
          y="178"
        >
          ✦
        </tspan>
      </text>
      <text
        fontFamily="ZapfDingbatsITC, Zapf Dingbats"
        fontSize="13"
        fill="#FFF"
      >
        <tspan
          x="71"
          y="168"
        >
          ✦
        </tspan>
      </text>
      <g opacity=".181">
        <use
          fill="#FFF"
          xlinkHref="#a"
        />
        <use
          stroke="#292929"
          mask="url(#i)"
          strokeWidth="4"
          xlinkHref="#a"
        />
      </g>
      <g transform="translate(72 63)">
        <use
          fill="#FFF"
          xlinkHref="#b"
        />
        <use
          stroke="#292929"
          mask="url(#j)"
          strokeWidth="4"
          xlinkHref="#b"
        />
        <path
          fill="#F5F5F5"
          d="M6 51h12v12H6zM21 51h41v12H21zM6 67h12v12H6zM21 67h41v12H21z"
        />
        <ellipse
          fill="#FF9B9B"
          cx="13"
          cy="36.5"
          rx="5"
          ry="1.5"
        />
        <ellipse
          fill="#FF9B9B"
          cx="55"
          cy="36.5"
          rx="5"
          ry="1.5"
        />
        <use
          fill="#DBDBDB"
          xlinkHref="#c"
        />
        <use
          stroke="#292929"
          mask="url(#k)"
          strokeWidth="4"
          xlinkHref="#c"
        />
        <path
          d="M23.507 29.012A6.51 6.51 0 0 0 17.5 25a6.51 6.51 0 0 0-6.007 4.012M55.507 29.012A6.51 6.51 0 0 0 49.5 25a6.51 6.51 0 0 0-6.007 4.012"
          stroke="#292929"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g transform="translate(72 60)">
        <g transform="translate(0 3)">
          <use
            fill="#FFF"
            xlinkHref="#d"
          />
          <use
            stroke="#292929"
            mask="url(#l)"
            strokeWidth="4"
            xlinkHref="#d"
          />
          <path
            fill="#F5F5F5"
            d="M6 51h12v12H6zM21 51h41v12H21zM6 67h12v12H6zM21 67h41v12H21z"
          />
          <ellipse
            fill="#FF9B9B"
            cx="13"
            cy="36.5"
            rx="5"
            ry="1.5"
          />
          <ellipse
            fill="#FF9B9B"
            cx="55"
            cy="36.5"
            rx="5"
            ry="1.5"
          />
          <use
            fill="#DBDBDB"
            xlinkHref="#e"
          />
          <use
            stroke="#292929"
            mask="url(#m)"
            strokeWidth="4"
            xlinkHref="#e"
          />
          <path
            d="M23.507 29.012A6.51 6.51 0 0 0 17.5 25a6.51 6.51 0 0 0-6.007 4.012M55.507 29.012A6.51 6.51 0 0 0 49.5 25a6.51 6.51 0 0 0-6.007 4.012"
            stroke="#292929"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <use
          stroke="#292929"
          mask="url(#n)"
          strokeWidth="4"
          fill="#FFF"
          transform="rotate(-139 62.926 6.86)"
          xlinkHref="#f"
        />
        <path
          d="M59.5 23c2.485 0 4.5-1.977 4.5-4.415 0-2.438-3.353-6.86-3.353-6.86-.633-.9-1.672-.9-2.294 0 0 0-3.353 4.422-3.353 6.86C55 21.023 57.015 23 59.5 23Z"
          fill="#7A8FE7"
        />
        <use
          stroke="#292929"
          mask="url(#o)"
          strokeWidth="4"
          fill="#FFF"
          transform="rotate(-139 62.926 6.86)"
          xlinkHref="#g"
        />
        <path
          d="M59.5 23c2.485 0 4.5-1.977 4.5-4.415 0-2.438-3.353-6.86-3.353-6.86-.633-.9-1.672-.9-2.294 0 0 0-3.353 4.422-3.353 6.86C55 21.023 57.015 23 59.5 23Z"
          fill="#7A8FE7"
        />
      </g>
      <g transform="translate(126 134)">
        <use
          fill="#FFF"
          xlinkHref="#h"
        />
        <use
          stroke="#292929"
          mask="url(#p)"
          strokeWidth="4"
          xlinkHref="#h"
        />
      </g>
      <g transform="translate(135 141)">
        <path
          stroke="#292929"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m.489 11.406 5.407 4 5.407-4"
        />
        <rect
          fill="#292929"
          x="5"
          width="2"
          height="16"
          rx="1"
        />
      </g>
    </g>
  </svg>
));

GenericPreviewIcon.displayName = "GenericPreviewIcon";
export default GenericPreviewIcon;
